module.exports = __webpack_public_path__ + "files/8be9c1dc0b7c93e1d8ecdcb888fc734e.png";